export enum AuctionListSortOption {
  Ordinal,
  TimeRemaining,
}
